import { useState, useContext } from "react";
import { Box, Button, TextField, MenuItem } from "@mui/material";
import QuestionElement from "./QuestionElement";
import { createQuestion, updateBlock } from "../axios/axiosFunctions";
import { AssessmentContext } from "../contexts/assessments";

const QuestionCard = ({ questions, color, blockId }) => {
    const { refetchAssessments } = useContext(AssessmentContext);
    const [adding, setAdding] = useState(false);
    const [text, setText] = useState("");
    const [typeQ, setTypeQ] = useState("mo");
    const [saving, setSaving] = useState(false);

    const resetForm = () => {
        setText("");
        setTypeQ("mo");
        setAdding(false);
    };

    const handleAdd = async () => {
        if (!text.trim() || saving || !blockId) return;
        setSaving(true);
        try {
            const res = await createQuestion({ text: text.trim(), typeQ });
            const newId = res?.question?._id;
            if (newId) {
                const existingIds = (questions || []).map((q) => q._id);
                await updateBlock(blockId, { questions: [...existingIds, newId] });
                await refetchAssessments();
                resetForm();
            }
        } finally {
            setSaving(false);
        }
    };

    return (
        <>
            {questions &&
                questions?.map((q, i) => (
                    <QuestionElement key={q._id || i} text={q.text} qId={q._id} typeQ={q.typeQ} />
                ))}

            {adding ? (
                <Box sx={{ backgroundColor: "white", padding: "20px", borderRadius: "5px", marginTop: "10px" }}>
                    <TextField
                        fullWidth
                        multiline
                        label="Question text"
                        value={text}
                        onChange={(e) => setText(e.target.value)}
                        color="primary"
                        sx={{ marginBottom: "12px" }}
                    />
                    <TextField
                        select
                        fullWidth
                        label="Type"
                        value={typeQ}
                        onChange={(e) => setTypeQ(e.target.value)}
                        sx={{ marginBottom: "12px" }}
                    >
                        <MenuItem value="mo">Multiple choice (rating)</MenuItem>
                        <MenuItem value="op">Open-ended (free text)</MenuItem>
                    </TextField>
                    <Button
                        onClick={handleAdd}
                        disabled={saving || !text.trim()}
                        variant="contained"
                        sx={{ marginRight: "10px" }}
                    >
                        {saving ? "Saving..." : "Save question"}
                    </Button>
                    <Button onClick={resetForm} color="secondary" disabled={saving}>
                        Cancel
                    </Button>
                </Box>
            ) : (
                <Button
                    variant="contained"
                    onClick={() => setAdding(true)}
                    sx={{ color: `${color}`, backgroundColor: "white", marginTop: "20px" }}
                >
                    Add question
                </Button>
            )}
        </>
    );
};

export default QuestionCard;
